import * as React from "react";

import { PerilDataSource } from "./util";
import styles from "./SourceBadge.module.css";

// Real pricing sources plus the display-only pseudo-sources the layers grid
// uses for rows with no single resolved vendor.
export type DisplayPerilDataSource = PerilDataSource | "lum" | "eqbd" | "mix";

export const SOURCE_LABELS: Record<DisplayPerilDataSource, string> = {
  air: "AIR",
  rms: "RMS",
  spatialkat: "KAT",
  rms_22: "RMS 22",
  rms_22_air_50_50: "Blended (RMS 22/AIR)",
  lum: "LUM",
  eqbd: "EQBD",
  mix: "MIX",
};

const SOURCE_BADGE_CLASSES: Record<DisplayPerilDataSource, string> = {
  air: "air",
  rms: "rms",
  spatialkat: "kat",
  rms_22: "rms",
  rms_22_air_50_50: "blend",
  lum: "lum",
  eqbd: "lum",
  mix: "lum",
};

// The per-provider source pill used across the Layers tab (grid + model
// breakdown), so the color theming stays consistent. ``label`` overrides the
// default source text while keeping the source's color (e.g. an explicit
// "RMS 22" / "RMS 25" for the RMS source).
export const SourceBadge: React.FC<{
  source: DisplayPerilDataSource;
  label?: string;
}> = ({ source, label }) => (
  <span
    className={`${styles.badge} ${styles[SOURCE_BADGE_CLASSES[source]] ?? ""}`}
  >
    {label ?? SOURCE_LABELS[source]}
  </span>
);
